export default __webpack_public_path__ + "static/media/3.2c86752c.svg";